import React from 'react';

import { IconProps } from '../types';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

import styles from '../Icons.module.scss';

const PartialCheckIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <path
                d="M8.0002 2C5.58687 2 3.30687 3.47333 2.39354 5.86C1.21354 8.95333 2.76687 12.42 5.8602 13.6C6.56687 13.8667 7.28687 13.9933 8.0002 13.9933"
                stroke={color}
                strokeWidth="1.42"
            />
            <path
                d="M5.31348 8.39324L6.6986 9.77836C6.77675 9.85652 6.90348 9.85646 6.98156 9.77824L10.6801 6.07324"
                stroke={color}
            />
            <path
                d="M5.86333 13.6022C8.96108 14.778 12.4229 13.2261 13.6047 10.1344C14.7865 7.04258 13.2287 3.57477 10.1369 2.39297C7.03916 1.21714 3.57732 2.769 2.39552 5.86078C1.21372 8.95256 2.77155 12.4204 5.86333 13.6022Z"
                stroke={color}
                strokeDasharray="2.84 2.84"
            />
        </svg>
    );
};

export default React.memo(PartialCheckIcon);
